function ReportForm() {
    return ( <>
    
    this is Report Form Page
    </> );
}

export default ReportForm;